import 'edge/quoteandbind/common/models/Submission';

export default ['JsonRPCService', 'qnb.endpointConfig', 'qnb.xCenterRouteConfig', function (JsonRPCService, endpointConfig, xCenterRouteConfig) {

    var endpoint = endpointConfig.cpCoverablesEndpoint;
    var xCenterRoute = xCenterRouteConfig;

    return {
        addCPLocation: function addCPLocation(quoteID, cpLocation, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'addLocation', [quoteID, cpLocation, sessionUUID]);
        },
        updateCPLocation: function updateCPLocation(quoteID, cpLocation, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateLocation', [quoteID, cpLocation, sessionUUID]);
        },
        removeCPLocation: function removeCPLocation(quoteID, cpLocation, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'removeLocation', [quoteID, cpLocation, sessionUUID]);
        },
        addCPBuilding: function addCPBuilding(quoteID, cpLocationId, cpBuilding, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'addBuilding', [quoteID, cpLocationId, cpBuilding, sessionUUID]);
        },
        updateCPBuilding: function updateCPBuilding(quoteID, cpLocationId, cpBuilding, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateBuilding', [quoteID, cpLocationId, cpBuilding, sessionUUID]);
        },
        removeCPBuilding: function removeCPBuilding(quoteID, cpLocationId, cpBuildingId, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'removeBuilding', [quoteID, cpLocationId, cpBuildingId, sessionUUID]);
        },
        updateCPBuildingCoverages: function updateCPBuildingCoverages(quoteID, cpLocationId, cpBuilding, sessionUUID) {
            return JsonRPCService.send(xCenterRoute, endpoint, 'updateBuildingCoverages', [quoteID, cpLocationId, cpBuilding, sessionUUID]);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/cp/services/CPCoverablesService.js
// module id = 2144
// module chunks = 0